$('.btn-service').click(function (event) {
    event.preventDefault();
    $("#" + $(this).data("for")).val($(this).data("id"));
    checkServiceSelected($(this).data("for"));
});

function checkServiceSelected(element) {
    const selectedValue = $("#" + element).val();
    if(selectedValue) {
        $(".btn-service").each(function () {
            if ($(this).data("for") === element && $(this).data("id") == selectedValue) {
                $(this).addClass("selected");
            } else {
                $(this).removeClass("selected");
            }
        });
        $("#btn-checkout-submit").show();
    }
    else {
        $("#btn-checkout-submit").hide();
    }
}

$(".edit-editor-modal-button").on('click', function () {
    $("#editor-modal-continue-button").attr("href", $(this).data("href"));
})

$(".delete-editor-modal-button").on('click', function () {
    $("#editor-modal-continue-button").attr("href", $(this).data("href"));
})

$(document).ready(function() {

    $(window).keydown(function(event){
        if( (event.keyCode == 13) ) {
            event.preventDefault();
            return false;
        }
    });

    if($('#checkout-current-step').data("page") === "delivery") {
        checkServiceSelected("c_deliveryoption");
    }
    if($('#checkout-current-step').data("page") === "payment") {
        checkServiceSelected("c_paymentoption");
    }
    if($('#checkout-current-step').data("page") === "process") {
        let form = $('#checkout-form');
        form.on('submit', function(e) {
            $.LoadingOverlay("show", {});
        });
    }

    var customAdapter = $.fn.select2.amd.require('select2/data/customAdapter');

    function checkModal(modalId) {
        if($("#" + modalId).length) {
            return $("#" + modalId);
        }
        else {
            return $(document.body);
        }
    }

    $("#address-billing-state_id").select2({
        theme: "bootstrap4",
        minimumResultsForSearch: 10,
        dataAdapter: customAdapter,
        sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
        dropdownParent: checkModal("billing-address-modal"),
        placeholder: function() {
            $(this).data('placeholder');
        },
    });

    $('[id^="address-delivery-state_id_"]').each(function(index) {
        $(this).select2({
            theme: "bootstrap4",
            minimumResultsForSearch: 10,
            dataAdapter: customAdapter,
            sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
            dropdownParent: checkModal("shipping-address_modal_" + index),
            placeholder: function() {
                $(this).data('placeholder');
            },
        });
    });

    if($("#cart-type").length) {
        let url = new URL(window.location.href);
        if(!url.searchParams.get("cart_type")) {
            console.log(url.searchParams.get("cart_type"));
            url.searchParams.set('cart_type', $("#cart-type").data("type"));
        }

        let state = history.state;
        let title = document.title;
        history.pushState(state, title, url);
    }
});

$('#checkout-guest').click(function (event) {
    event.preventDefault();
    $.ajax({
        type: 'POST',
        url: '/set_checkout_as_guest',
    })
    $("#checkout-auth").hide();
    $("#checkout-funnel").show();
});

$('#btn-checkout-submit,.checkout-progress-bar a,#promo-apply,.promo-delete').click(function (event) {
    let form = $('#checkout-form');
    let step = $('#checkout-current-step').data("page");

    //Se sono in versione modale NON devo lanciare la validazione JS perchè gli eventuali elementi invalidi non sono mostrabili
    if(step === "address" && !$('#billing-address-modal').length) {
        if(form[0]) {
            if(form[0].checkValidity()) {
                form.on('submit', function(e) {
                    $.LoadingOverlay("show", {});
                });
            }
            else {
                event.preventDefault();
                form[0].reportValidity();
            }
        }
    }
    form.on('submit', function(e) {
        $.LoadingOverlay("show", {});
    });
});

$(".checkout-button a").click(function(event) {
    $.LoadingOverlay("show", {});
})

$('[id^="product-detail-show-more-button_"]').on('click', function(e) {
    elemId = $(e.target).attr("id").split("_")[1];
    $("#product-detail-show-more-button_" + elemId).hide();
    $("#product-detail-show-less-button_" + elemId).show();
});

$('[id^="product-detail-show-less-button_"]').on('click', function(e) {
    elemId = $(e.target).attr("id").split("_")[1];
    $("#product-detail-show-more-button_" + elemId).show();
    $("#product-detail-show-less-button_" + elemId).hide();
});
